import { mainnet, arbitrum, sepolia, solana, solanaTestnet, solanaDevnet } from '@reown/appkit/networks';
import { EthersAdapter } from '@reown/appkit-adapter-ethers';
import { SolanaAdapter } from '@reown/appkit-adapter-solana/react';


export const projectId = "7a4359161ff26273ae8187a437c04cbc"; // public projectId only to use on localhost

if (!projectId) {
  throw new Error('Project ID is not defined');
}

// Create a metadata object - optional
export const metadata = {
  name: "RZTO",
  description: "RZTO - The Future of Mobile Commerce & Blockchain ",
  url: "https://www.rzto.io",
  icons: ["https://harlequin-eligible-bee-657.mypinata.cloud/ipfs/bafybeig2n25josgski27ewh6bl6r7uajtjfvnva4ilnbm3djzwp32pkfbu"],
};

// For custom networks visit -> https://docs.reown.com/appkit/react/core/custom-networks
export const networks = [mainnet, arbitrum, sepolia, solana, solanaTestnet, solanaDevnet];

// Set up Adapters
export const ethersAdapter = new EthersAdapter();
export const solanaWeb3JsAdapter = new SolanaAdapter();
